/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * フォントファミリー (null許容)
 * @export
 */
export const FontFamilyNullable = {
  Gothic: 'gothic',
  Mincho: 'mincho',
  Monospace: 'monospace'
} as const
export type FontFamilyNullable = typeof FontFamilyNullable[keyof typeof FontFamilyNullable]

export function FontFamilyNullableFromJSON(json: any): FontFamilyNullable {
  return FontFamilyNullableFromJSONTyped(json, false)
}

export function FontFamilyNullableFromJSONTyped(json: any, ignoreDiscriminator: boolean): FontFamilyNullable {
  return json as FontFamilyNullable
}

export function FontFamilyNullableToJSON(value?: FontFamilyNullable | null): any {
  return value as any
}
